import { combineReducers } from "redux";
import { reducer as reduxFormReducer } from "redux-form";

import runsheets from "./runsheetsReducer";
import jobs from "./jobsReducer";
import jobAttachments from "./jobAttachmentsReducer";
import currentJobId from "./currentJobIdReducer";
import vehicles from "./vehiclesReducer";
import locations from "./locationsReducer";
import users from "./usersReducer";
import filters from "./filtersReducer";
import date from "./dateReducer";
import display from "./displayReducer";
import jobItems from "./itemReducer";

export default combineReducers({
  runsheets,
  jobs,
  form: reduxFormReducer,
  currentJobId,
  vehicles,
  locations,
  users,
  jobAttachments,
  filters,
  date,
  display,
  jobItems
});



// WEBPACK FOOTER //
// ./src/reducers/index.js